module.exports = __webpack_public_path__ + "static/media/online-registration-banner1.d5eb3c40.png";